<div [ngClass]="{ 'menu-superior-sticky': stickyMenu }"></div>
<mat-tab-group mat-align-tabs="center" [(selectedIndex)]="selected" (focusChange)="tabChanged($event)">
	<mat-tab></mat-tab>
	<mat-tab *ngFor="let season of seasons" [label]="season"></mat-tab>
</mat-tab-group>
